import { doc, collection, onSnapshot, deleteDoc, updateDoc, addDoc, query, orderBy } from 'firebase/firestore'

const state = () => ({
  allLocations: null,
  locationsListenerUnsub: null
})

const getters = {
  allLocations: state => state.allLocations,
  locationById: (state) => (id) => {
    if (state.allLocations) {
      const targetLocaction = state.allLocations.find(location => location.id === id)
      if (targetLocaction) {
        return targetLocaction.name
      } else {
        return null
      }
    } else {
      return null
    }
  },
  locationsListenerUnsub: state => state.locationsListenerUnsub
}

const mutations = {
  setAllLocations (state, val) {
    state.allLocations = val
  },
  setLocationsListenerUnsub (state, val) {
    state.locationsListenerUnsub = val
  }
}

const actions = {
  locationsListener ({ commit, state, rootState }) {
    if (state.locationsListenerUnsub != null) {
      return
    }

    const q = query(collection(rootState.firestore, 'locations'), orderBy('order'))

    const unsub = onSnapshot(q, (snapshot) => {
      const locations = []
      snapshot.forEach((location) => {
        const copy = location.data()
        copy.id = location.id
        locations.push(copy)
      })
      commit('setAllLocations', locations)
    })

    commit('setLocationsListenerUnsub', unsub)
  },

  stopLocationsListener ({ state, commit }) {
    if (state.locationsListenerUnsub) state.locationsListenerUnsub()
    commit('setLocationsListenerUnsub', null)
  },

  async firestoreDeleteLocation ({ rootState }, locationId) {
    console.log('Deleting location', locationId)
    await deleteDoc(doc(rootState.firestore, 'locations', locationId))
  },

  async firestoreUpdateLocation ({ rootState }, location) {
    const updateData = {}
    if (location.name !== undefined) updateData.name = location.name
    if (location.order !== undefined) updateData.order = location.order
    if (location.group !== undefined) updateData.group = location.group
    await updateDoc(doc(rootState.firestore, 'locations', location.id), updateData)
  },

  async firestoreAddLocation ({ rootState, state }, location) {
    const order = state.allLocations ? state.allLocations.length : 0
    const addData = {
      name: location.name,
      order: order
    }
    if (location.group !== undefined) {
      addData.group = location.group
    }
    await addDoc(collection(rootState.firestore, 'locations'), addData)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
